import { atom, useAtomValue, useSetAtom } from 'jotai';

export const selectedPlanIdAtom = atom<number | null>(null);

export const useSelectedBuyingPlanId = () => {
  return useAtomValue(selectedPlanIdAtom);
};

export const useSetSelectedBuyingPlanId = () => {
  return useSetAtom(selectedPlanIdAtom);
};
